import { FC } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import { Button, Flex, Table } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import FormModal from '../../../components/form-modal/form-modal'
import StampWriteOffForm from '../../../components/forms/stamp-write-off-form/stamp-write-off-form'
import Title from 'antd/es/typography/Title'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'
import useEndpointQueryParams from '../../../hooks/table-pages/use-endpoint-query-parameters'
import { useGetStampWriteOffsQuery } from '../../../store/api/stamp-write-offs-api'
import useTablePagination from '../../../hooks/table-pages/use-table-pagination'
import StampWriteOff from '../../../types/api/stamp-write-off'
import { getColumns } from './constants/columns'

interface StampWriteOffsPageProps {}

const StampWriteOffsPage: FC<StampWriteOffsPageProps> = () => {
    const params = useEndpointQueryParams({ deserializeFilters: () => ({}) })
    const { data, isLoading, refetch } = useGetStampWriteOffsQuery({ ...params, populate: '*' })
    const pagination = useTablePagination(params, data)
    const dataSource: StampWriteOff[] = data?.data || []
    const columns = getColumns(refetch)

    return (
        <PageLayout title={'Списания штампов'}>
            <Flex style={{ flex: '0 0 auto' }} justify={'end'}>
                <FormModal
                    width={800}
                    renderContent={onClose => (
                        <>
                            <Title level={2} style={{ marginTop: 0 }}>
                                Списание штампа
                            </Title>
                            <StampWriteOffForm
                                onSuccess={() => {
                                    refetch()
                                    onClose()
                                }}
                            />
                        </>
                    )}
                    renderOpener={onOpen => (
                        <Button type={'primary'} icon={<PlusOutlined />} onClick={onOpen}>
                            Добавить списание
                        </Button>
                    )}
                />
            </Flex>

            <TableWrapper>
                <Table
                    bordered
                    columns={columns}
                    dataSource={dataSource}
                    pagination={pagination}
                    rowKey={r => r.documentId}
                    loading={isLoading}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default StampWriteOffsPage
